/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import GruposMenu from './GruposMenu';
import MenusMenu from './MenusMenu';
import ModulosMenu from './ModulosMenu';
import './styles.css';
import SubMenus from './SubMenus';
import UsuariosMenu from './UsuariosMenu';

const usuarioDev = sessionStorage.getItem('@auth/usuarioDev') === 'true';
const usuarioSup = sessionStorage.getItem('@auth/usuarioSup') === 'true';

const DevMenu = ({
  openUser,
  setOpenUser,
  openGroup,
  setOpenGroup,
  openModule,
  setOpenModule,
  openMenu,
  setOpenMenu,
  openSubMenu,
  setOpenSubMenu,
}) => (
  <div className="menuContainer">
    <button
      type="button"
      onClick={() => {
        setOpenModule(!openModule);
      }}
    >
      Módulos
      {openModule ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openModule ? <ModulosMenu /> : ''}

    <button
      type="button"
      onClick={() => {
        setOpenMenu(!openMenu);
      }}
    >
      Menus
      {openMenu ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openMenu ? <MenusMenu /> : ''}

    <button
      type="button"
      onClick={() => {
        setOpenSubMenu(!openSubMenu);
      }}
    >
      Sub Menus
      {openSubMenu ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openSubMenu ? <SubMenus /> : ''}

    <button
      type="button"
      onClick={() => {
        setOpenGroup(!openGroup);
      }}
    >
      Grupos
      {openGroup ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openGroup ? (
      <GruposMenu usuarioDev={usuarioDev} usuarioSup={usuarioSup} />
    ) : (
      ''
    )}

    <button
      type="button"
      onClick={() => {
        setOpenUser(!openUser);
      }}
    >
      Usuários
      {openUser ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openUser ? <UsuariosMenu /> : ''}

    {/*  <button
      type="button"
      onClick={() => {
        setOpenPage(!openPage);
      }}
    >
      Páginas
      {openPage ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openPage ? <PaginasMenu /> : ''} */}
  </div>
);

const SupMenu = ({ openUser, setOpenUser, openGroup, setOpenGroup }) => (
  <div className="menuContainer">
    <button
      type="button"
      onClick={() => {
        setOpenGroup(!openGroup);
      }}
    >
      Grupos
      {openGroup ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openGroup ? <GruposMenu /> : ''}
    <button
      type="button"
      onClick={() => {
        setOpenUser(!openUser);
      }}
    >
      Usuários
      {openUser ? <FaAngleUp /> : <FaAngleDown />}
    </button>
    {openUser ? <UsuariosMenu /> : ''}
  </div>
);

function SideMenu() {
  const [openUser, setOpenUser] = useState(false);
  const [openGroup, setOpenGroup] = useState(false);
  const [openModule, setOpenModule] = useState(false);
  const [openPage, setOpenPage] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);

  const usuarioDev01 = sessionStorage.getItem('@auth/usuarioDev') === 'true';
  const usuarioSup01 = sessionStorage.getItem('@auth/usuarioSup') === 'true';

  return (
    <>
      {usuarioDev01 && !usuarioSup01 ? (
        <DevMenu
          openUser={openUser}
          setOpenUser={setOpenUser}
          openGroup={openGroup}
          setOpenGroup={setOpenGroup}
          openModule={openModule}
          setOpenModule={setOpenModule}
          openPage={openPage}
          setOpenPage={setOpenPage}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          openSubMenu={openSubMenu}
          setOpenSubMenu={setOpenSubMenu}
        />
      ) : (
        <SupMenu
          openUser={openUser}
          setOpenUser={setOpenUser}
          openGroup={openGroup}
          setOpenGroup={setOpenGroup}
        />
      )}
    </>
  );
}

export default SideMenu;
